// src/utils/deliveryHelpers.js

export const DELIVERY_STATUS = {
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  ON_THE_WAY: 'ON_THE_WAY',
  BOOK_WITH_ME: 'BOOK_WITH_ME',
  RETURN_REQUESTED: 'RETURN_REQUESTED',
  PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
  RETURN_IN_TRANSIT: 'RETURN_IN_TRANSIT',
  RETURNED: 'RETURNED',
  CANCELLED: 'CANCELLED'
};

export const STATUS_COLORS = {
  PROCESSING: 'bg-blue-100 text-blue-800',
  SHIPPED: 'bg-purple-100 text-purple-800',
  ON_THE_WAY: 'bg-yellow-100 text-yellow-800',
  BOOK_WITH_ME: 'bg-green-100 text-green-800',
  RETURN_REQUESTED: 'bg-orange-100 text-orange-800',
  PICKUP_SCHEDULED: 'bg-indigo-100 text-indigo-800',
  RETURN_IN_TRANSIT: 'bg-pink-100 text-pink-800',
  RETURNED: 'bg-gray-100 text-gray-800',
  CANCELLED: 'bg-red-100 text-red-800'
};

export const STATUS_LABELS = {
  PROCESSING: 'Processing',
  SHIPPED: 'Shipped',
  ON_THE_WAY: 'On the Way',
  BOOK_WITH_ME: 'Delivered',
  RETURN_REQUESTED: 'Return Requested',
  PICKUP_SCHEDULED: 'Pickup Scheduled',
  RETURN_IN_TRANSIT: 'Return in Transit',
  RETURNED: 'Returned',
  CANCELLED: 'Cancelled'
};

export const getNextStatus = (currentStatus) => {
  const statusFlow = {
    PROCESSING: 'SHIPPED',
    SHIPPED: 'ON_THE_WAY',
    ON_THE_WAY: 'BOOK_WITH_ME',
    RETURN_REQUESTED: 'PICKUP_SCHEDULED',
    PICKUP_SCHEDULED: 'RETURN_IN_TRANSIT',
    RETURN_IN_TRANSIT: 'RETURNED',
  };
  return statusFlow[currentStatus] || null;
};

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || 'bg-gray-100 text-gray-800';
};

export const getStatusLabel = (status) => {
  return STATUS_LABELS[status] || status;
};

export const canUpdateStatus = (status) => {
  const terminalStatuses = ['CANCELLED', 'RETURNED'];
  const readOnlyStatuses = ['BOOK_WITH_ME']; // User has the book, no delivery action needed
  return !terminalStatuses.includes(status) && !readOnlyStatuses.includes(status);
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch (error) {
    return 'Invalid Date';
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return 'Invalid Date';
  }
};
